import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { IdentityService } from './core/services/identity.service';
import { NativeBridgeService } from './core/services/native-bridge.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(
    private translateService: TranslateService,
    private router: Router,
    private identity: IdentityService,
    private nativeBridgeWindow: NativeBridgeService
  ) {
    this.translateService.use('es');
  }

  ngOnInit() {
    this.nativeBridgeWindow.$messageReceived.subscribe((val) => {
      console.log(val);

      console.log('Version:', require('../../package.json').version);
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/') {
          let user = this.identity.getUser();
          if (!user) {
            this.router.navigate(['login']);
          }
          if (user?.rol.id === 7) {
            this.router.navigate(['user/cashin-cashout']);
          }
          if (user?.rol.id === 3) {
            this.router.navigate(['user/account-yacare']);
          }
        }
      }
    });
  }
}
